__webpack_require__.p = "https://login.adgebra.co/adgebraui/";